// extracted by mini-css-extract-plugin
module.exports = {"container":"filter_dropdown_header-module__container--4U_ob","title":"filter_dropdown_header-module__title--1r8SM"};